import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-home-crm',
    templateUrl: './home-crm.component.html',
    styleUrls: ['./home-crm.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HomeCrmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
